import styled from 'styled-components'

import * as CommonStyles from '../Common/styles'

export const Wrapper = styled(CommonStyles.Wrapper)`
  padding: 5px 24px 0 32px;
`
